import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ApiService, AuthService, TohumUiModule, TranslateService } from '@anadolu-commons/tohum-ui';
import { SharedService } from '../shared/shared.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { AofMenuComponent, AofMenuItem } from '../shared/aof-menu/aof-menu.component';
import { AofMenuService } from '../shared/services/aof-menu.service';
import { OgrenciSecimComponent } from '../shared/ogrenci-secim/ogrenci-secim.component';
import { FuncsService } from '../services/funcs.service';
import { Moduller } from '../shared/ogrenci-secim/ogrenci-secim.model';
import { HeaderLogoComponent } from '../shared/header-logo/header-logo.component';
import { UserPanelComponent } from '../shared/user-panel/user-panel.component';
import { NavItemComponent } from '../shared/nav-item/nav-item.component';

@Component({
    selector: 'app-master-page',
    standalone: true,
    imports: [TohumUiModule, HeaderLogoComponent, NavItemComponent, UserPanelComponent, OgrenciSecimComponent, AofMenuComponent],
    templateUrl: './master-page.component.html',
    styleUrls: ['./master-page.component.scss']
})
export class MasterPageComponent implements OnInit {
    @Input() menu: any;
    @Input() title: string;
    @Input() breadcrumb: any;
    @Input() sidebarNarrow: boolean;

    user: any;
    loginMi: boolean = false;
    adminMi: boolean = false;
    anaSayfadaMi: boolean = false;
    onBasvuruyaBasladiMi: boolean = false;
    basvuruyaBasladiMi: boolean = false;

    modalGoruntule: boolean = false;

    moduller = Moduller;

    profilId: string;
    adayBilgi: string;
    adaySorgulamasiYapildiMi: boolean = false;
    resimBasariliMi: boolean = false;

    dilSecimiAcikMi: boolean = false;
    isMobileResolution: boolean = false;
    isMobileAdminResolution: boolean = false;

    currentLang: string;



    constructor(
        private authService: AuthService, private sharedService: SharedService, private apiService: ApiService, private aofMenuService: AofMenuService,
        private translateService: TranslateService, private funcs: FuncsService, private router: Router) {

        this.sharedService.profil$.subscribe((aday) => {
            if (aday) {
                this.profilId = aday.profilId;
                this.adaySorgulamasiYapildiMi = true;
            }
        });

        this.sharedService.profilAdSoyad$.subscribe((data) => {
            if (data) {
                this.adayBilgi = data.ad + ' ' + data.soyad;
            }
        });


        this.sharedService.onBasvuruAsamasindaMi$.subscribe((data) => {
            this.onBasvuruyaBasladiMi = data;
        });

        this.sharedService.basvuruAsamasindaMi$.subscribe((data) => {
            this.basvuruyaBasladiMi = data;
        });

        // Track ana-sayfa route
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.anaSayfadaMi = event.url === '/' || event.url === '/#';
        });


    }

    ngOnInit(): void {

        this.currentLang = this.translateService.getLang();

        this.checkResolution();
        this.loginMi = this.authService.isAuthenticated();
        this.user = this.authService.getUser();
        this.adminMi = this.authService.hasPermissions(['Admin']);

        if (this.user !== null && !this.sharedService.profilId$) {
            this.sorgula();
        }
        if (!this.loginMi || this.authService.hasPermissions(['DilSecimi'])) {
            this.dilSecimiAcikMi = true;
        }
    }

    modalKapat() {
        this.modalGoruntule = false;
    }

    sorgula() {
        this.apiService.get('ogrenci-secimi/giris-yapan-aday-profil-sorgula/',
            {
                tcNo: this.user.id,
                girisYapanId: this.user.id,
                adminMi: false,
                kendiTcNoKullanmakIstiyor: true,
            })
            .pipe(
                map(json => json.data)
            )
            .subscribe(result => {
                this.sharedService.setProfilBilgi(result, false);
                this.sharedService.setAdSoyadBilgi(result);
            }, error => {
                this.funcs.hataMesajiVer(error);
            });
    }

    setLang(lang: string) {
        this.currentLang = lang;
        this.translateService.setLang(lang);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.checkResolution();
    }

    checkResolution() {
        if (typeof window !== 'undefined') {
            this.isMobileResolution = window.innerWidth < 992;
            this.isMobileAdminResolution = window.innerWidth < 1064;
        }
    }
}
